var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyFeature03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "600px",
    height: "600px",
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/menu/stroke/stock details") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/menu/stroke/stock-details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(153.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.747287,0 C174.983893,0 188.366227,12.1942539 190.200727,27.9067155 L207.199063,27.9062022 C218.74721,27.9062022 228.1089,37.2490324 228.1089,48.7739135 L228.108,54.77 L263.636279,54.7701543 C280.85951,54.7701543 295,68.2810847 295,85.1777152 L295,366.592439 C295,383.48907 280.85951,397 263.636279,397 L31.3637208,397 C14.1397384,397 -2.84217094e-14,383.489329 -2.84217094e-14,366.592439 L-2.84217094e-14,85.1777152 C-2.84217094e-14,68.2808255 14.1397384,54.7701543 31.3637208,54.7701543 L66.89,54.77 L66.8908928,48.7739135 C66.8908928,37.2490324 76.2525833,27.9062022 87.8007297,27.9062022 L103.61072,27.9067155 C105.44522,12.1942539 118.827554,0 135.064161,0 L158.747287,0 Z M66.89,74.423 L29.5273804,74.4236197 C23.4380941,74.4236197 18.6833333,78.9217935 18.6833333,84.2404079 L18.6833333,367.270198 C18.6833333,372.588812 23.4380941,377.086986 29.5273804,377.086986 L265.47262,377.086986 C271.561294,377.086986 276.316667,372.588386 276.316667,367.270198 L276.316667,84.2404079 C276.316667,78.9222195 271.561294,74.4236197 265.47262,74.4236197 L228.108,74.423 L228.1089,84.9651833 C228.1089,96.4900644 218.74721,105.832895 207.199063,105.832895 L87.8007297,105.832895 C76.2525833,105.832895 66.8908928,96.4900644 66.8908928,84.9651833 L66.89,74.423 Z M92.4799508,309 C97.8375544,309 102.197944,313.260981 102.344214,318.572519 L102.348005,318.848174 L102.348005,318.858804 C102.348005,324.205614 98.078423,328.557219 92.7561625,328.703195 L92.4799508,328.706978 L57.3883844,328.706978 C52.0307809,328.706978 47.6703917,324.445997 47.524121,319.134459 L47.5203299,318.858804 L47.5203299,318.848174 C47.5203299,313.501364 51.7899122,309.149759 57.1121728,309.003783 L57.3883844,309 L92.4799508,309 Z M92.4799508,227 C97.8375543,227 102.197943,231.260981 102.344214,236.572519 L102.348005,236.848174 L102.348005,236.858804 C102.348005,242.205614 98.078423,246.557219 92.7561624,246.703195 L92.4799508,246.706978 L57.3883844,246.706978 C52.0307808,246.706978 47.6703917,242.445997 47.524121,237.134459 L47.5203299,236.858804 L47.5203299,236.848174 C47.5203299,231.501364 51.7899122,227.149759 57.1121727,227.003783 L57.3883844,227 L92.4799508,227 Z M242.339252,144.329638 C247.696856,144.329638 252.057245,148.590619 252.203516,153.902157 L252.207307,154.177812 L252.207307,154.188442 C252.207307,159.535252 247.937725,163.886857 242.615464,164.032833 L242.339252,164.036616 L137.467008,164.036616 C132.109405,164.036616 127.749015,159.775636 127.602745,154.464098 L127.598954,154.188442 L127.598954,154.177812 C127.598954,148.831002 131.868536,144.479398 137.190796,144.333422 L137.467008,144.329638 L242.339252,144.329638 Z M92.8092286,144.329638 C98.1668321,144.329638 102.527221,148.590619 102.673492,153.902157 L102.677283,154.177812 L102.677283,154.188442 C102.677283,159.535252 98.4077007,163.886857 93.0854402,164.032833 L92.8092286,164.036616 L57.7176621,164.036616 C52.3600586,164.036616 47.9996694,159.775636 47.8533987,154.464098 L47.8496076,154.188442 L47.8496076,154.177812 C47.8496076,148.831002 52.1191899,144.479398 57.4414505,144.333422 L57.7176621,144.329638 L92.8092286,144.329638 Z M205.790926,48.296837 L88.2418613,48.296837 C88.1173772,48.296837 88.0163934,48.4080656 88.0163934,48.5451787 L88.0163934,84.7540914 C88.0163934,84.8912044 88.1173772,85.0024331 88.2418613,85.0024331 L205.790926,85.0024331 C205.91541,85.0024331 206.016393,84.8912044 206.016393,84.7540914 L206.016393,48.5451787 C206.016393,48.4080656 205.91541,48.296837 205.790926,48.296837 Z M159.969726,18.3527981 L133.872092,18.3527981 C128.056365,18.3527981 123.199323,22.4474782 122.037525,27.9057908 L171.804294,27.9057908 C170.642496,22.4474782 165.785453,18.3527981 159.969726,18.3527981 Z",
    id: "Colour",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(106.749562, 170.749562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(99.029383, 108.482250) rotate(-9.000000) translate(-99.029383, -108.482250) translate(14.029383, 12.110433)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 134.566959,
    y1: 146.005054,
    x2: 168.804802,
    y2: 191.926401,
    id: "Line-2",
    stroke: "#FFFFFF",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 19,
    cx: 85,
    cy: 85,
    r: 94.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 38,
    cx: 85,
    cy: 85,
    r: 66
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#666666",
    strokeWidth: 19,
    cx: 85,
    cy: 85,
    r: 75.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.566959,
    y1: 146.005054,
    x2: 168.804802,
    y2: 191.926401,
    id: "Line-2",
    stroke: "#666666",
    strokeWidth: 19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Line",
    stroke: "#666666",
    strokeWidth: 19,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "63.1826577 104.614513 87.6556636 128.555727 130.750438 72.0057413"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyFeature03);
export default __webpack_public_path__ + "static/media/key_feature_03.275492147252f26bb3d33f716f08327f.svg";
export { ForwardRef as ReactComponent };